import './Card.scss';

import cx from 'classnames';
import React from 'react';

import Badge from '../Badge';
import formatValue from '../DetailedList/formatValue';
import Icon from '../Icons';
import { IconNameType } from '../Icons/Icon';
import { ListItemType } from '../../types';
import { Tooltip } from '@nextui-org/react';
import { RiInformation2Line } from '@remixicon/react';

/**
 * Card component
 */
type CardProps = {
  label: string | number;
  badge?: string;
  subLabel?: string | number;
  icon?: IconNameType;
  level?: string;
  sideValue?: string;
  type?: ListItemType;
  formatCase?: string;
  isFirstWordBold?: boolean;
  tooltip?: string;
};
const Card: React.FC<CardProps> = (props) => {
  const {
    badge,
    icon,
    label,
    level,
    sideValue,
    subLabel,
    type,
    formatCase,
    isFirstWordBold,
    tooltip,
  } = props;
  const divCx = cx('Card shadow-medium', {
    'has-badge': badge,
    [`${level}`]: level,
  });

  const formattedLabel = formatValue({ type, value: label || '' });
  const formattedBadge = formatValue({
    type,
    value: badge || '',
    formatCase: formatCase,
  });

  return (
    <div className={divCx} data-testid="card">
      {sideValue && <div className="side-value">{sideValue}</div>}
      {icon && !sideValue && (
        <Icon icon={icon} className="side-value" size="lg" />
      )}
      <div className="main-value">
        {badge ? (
          <Badge level={level} label={formattedBadge} />
        ) : (
          <div className="empty-div" />
        )}
        <div className="label font-raleway capitalize">{formattedLabel}</div>
        <div>
          {isFirstWordBold ? (
            <div className="sub-label flex gap-1">
              {typeof subLabel === 'string' ? (
                <>
                  <span className="font-bold">{subLabel.split(' ')[0]}</span>
                  {' ' + subLabel.split(' ').slice(1).join(' ')}
                </>
              ) : (
                subLabel
              )}
              <Tooltip
                content={tooltip}
                placement="right"
                classNames={{
                  base: ['max-w-52'],
                }}
              >
                <div className="tooltip">
                  <RiInformation2Line size={18} />
                </div>
              </Tooltip>
            </div>
          ) : (
            <div className="sub-label">{subLabel}</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Card;
